<script lang="ts">
  import { observe } from "$lib/actions/observe";

  let { sectionLabel = "", headline = "", description = "", industries = [] as Array<{ name: string }> } = $props();
</script>

<section>
  <div class="container">
    <div class="section-divider fade-up" use:observe>
      {#if sectionLabel}<span class="section-label">{sectionLabel}</span>{/if}
      <h2>{headline}</h2>
      {#if description}
        <p>{description}</p>
      {/if}
    </div>
    <div class="values-grid stagger" use:observe style="text-align:center">
      {#each industries as industry}
        <div class="card">
          <div class="card-icon" style="background:var(--accent-bg);color:var(--accent);margin:0 auto 12px">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="22" height="22">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </div>
          <p style="font-size:0.85rem">{industry.name}</p>
        </div>
      {/each}
    </div>
  </div>
</section>
